import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VInput } from 'vuetify/lib/components/VInput';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 consumer-chains",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    attrs: {
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pa-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VRow, {
    staticClass: "ma-0"
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.table.name'),
      "hide-details": "auto",
      "data-cy": "integrationflowName"
    },
    model: {
      value: _vm.consumerModel.name,
      callback: function ($$v) {
        _vm.$set(_vm.consumerModel, "name", $$v);
      },
      expression: "consumerModel.name"
    }
  })], 1)], 1), _c(VRow, {
    staticClass: "ma-0"
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      "required": "",
      "disabled": !_vm.isCreateDialog,
      "data-cy": "integrationflowAccount"
    },
    model: {
      value: _vm.account,
      callback: function ($$v) {
        _vm.account = $$v;
      },
      expression: "account"
    }
  })], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.triggerSources,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "label": _vm.$i18n_t('Bridges.Consumers.chains.trigger'),
      "item-value": "value",
      "item-text": "text",
      "hide-details": "auto",
      "menu-props": {
        offsetY: true
      },
      "data-cy": "integrationflowTrigger"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v(_vm._s(data.item.text))];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                " + _vm._s(data.item.text) + "\n              ")]), _c(VListItemSubtitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.value)
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.consumerModel.trigger.source,
      callback: function ($$v) {
        _vm.$set(_vm.consumerModel.trigger, "source", $$v);
      },
      expression: "consumerModel.trigger.source"
    }
  }), _c('p', {
    staticClass: "card-description mt-2 mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('Bridges.Consumers.chains.triggerText'))
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('h4', {
    staticClass: "my-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Bridges.Consumers.chains.chainItems')))])]), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.chainItemTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Bridges.Consumers.chains.newChainItemType'),
      "rules": [_vm.chainErrorMessage],
      "item-value": "value",
      "item-text": "text",
      "hide-details": "auto",
      "data-cy": "integrationflowChainItem"
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [!_vm.readonly ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "disabled": !_vm.newChainItemType || _vm.chainItemTypes.findIndex(c => c.value === _vm.newChainItemType) < 0,
            "data-cy": "addNewChainItem"
          },
          on: {
            "click": _vm.addNewChainItem
          }
        }) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.newChainItemType,
      callback: function ($$v) {
        _vm.newChainItemType = $$v;
      },
      expression: "newChainItemType"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VDataTable, {
    attrs: {
      "items": _vm.consumerModel.chain,
      "headers": _vm.chainItemsTableHeader,
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', {
          staticStyle: {
            "width": "140px"
          }
        }, [!_vm.readonly ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-chevron-down",
            "disabled": items.index === _vm.consumerModel.chain.length - 1
          },
          on: {
            "click": function ($event) {
              return _vm.changeChainItemOrder(items.index, 'down');
            }
          }
        }) : _vm._e(), !_vm.readonly ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-chevron-up",
            "disabled": items.index === 0
          },
          on: {
            "click": function ($event) {
              return _vm.changeChainItemOrder(items.index, 'up');
            }
          }
        }) : _vm._e(), _vm._v("\n                #" + _vm._s(items.index + 1) + "\n              ")], 1), _c('td', {
          staticClass: "py-2"
        }, [items.item.action === 'ds-transform' ? [_c(VAutocomplete, {
          staticClass: "required",
          attrs: {
            "items": _vm.transformers,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "rules": _vm.transformerOrFilterRule(items.index),
            "label": _vm.$i18n_t('Bridges.Consumers.chains.transformer'),
            "item-value": "id",
            "item-text": "name",
            "hide-details": "auto",
            "dense": "",
            "data-cy": "chainItemTrafo"
          },
          model: {
            value: items.item.parameter.id,
            callback: function ($$v) {
              _vm.$set(items.item.parameter, "id", $$v);
            },
            expression: "items.item.parameter.id"
          }
        })] : items.item.action === 'ds-filter' ? [_c(VAutocomplete, {
          staticClass: "required",
          attrs: {
            "items": _vm.filters,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "rules": _vm.transformerOrFilterRule(items.index),
            "label": _vm.$i18n_t('Bridges.Consumers.chains.filter'),
            "item-value": "id",
            "item-text": "name",
            "hide-details": "auto",
            "dense": "",
            "data-cy": "chainItemFilter"
          },
          model: {
            value: items.item.parameter.id,
            callback: function ($$v) {
              _vm.$set(items.item.parameter, "id", $$v);
            },
            expression: "items.item.parameter.id"
          }
        })] : items.item.action === 'ds-bridge' ? _vm._l(items.item.parameter.configs, function (_, i) {
          return _c('span', {
            key: `chainstep_${items.index}_bridge_${i}`
          }, [_c(VRow, {
            staticClass: "ma-0 pa-0"
          }, [_c(VAutocomplete, {
            staticClass: "required",
            attrs: {
              "items": _vm.bridges,
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "rules": _vm.rulesForBridgeIdx(i),
              "label": _vm.$i18n_t('Bridges.Consumers.chains.connector'),
              "item-value": "id",
              "item-text": "name",
              "hide-details": "auto",
              "dense": "",
              "data-cy": "chainItemConnector"
            },
            on: {
              "change": function ($event) {
                return _vm.pickedBridge(i);
              }
            },
            scopedSlots: _vm._u([{
              key: "selection",
              fn: function (data) {
                return [_vm._v(_vm._s(data.item.name))];
              }
            }, {
              key: "item",
              fn: function (data) {
                return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                              " + _vm._s(data.item.name) + "\n                            ")]), _c(VListItemSubtitle, {
                  domProps: {
                    "innerHTML": _vm._s(data.item.displayName)
                  }
                })], 1)];
              }
            }, {
              key: "append-outer",
              fn: function () {
                return [!_vm.readonly ? _c('core-button', {
                  attrs: {
                    "color": _vm.color,
                    "prepend-icon": "fa-plus"
                  },
                  on: {
                    "click": function ($event) {
                      return _vm.addBridgeConfig(items.index);
                    }
                  }
                }) : _vm._e(), !_vm.readonly ? _c('core-button', {
                  attrs: {
                    "color": _vm.color,
                    "prepend-icon": "fa-trash-alt",
                    "disabled": i === 0 && items.item.parameter.configs.length === 1
                  },
                  on: {
                    "click": function ($event) {
                      return _vm.deleteBridgeConfig(items.index, i);
                    }
                  }
                }) : _vm._e()];
              },
              proxy: true
            }], null, true),
            model: {
              value: items.item.parameter.configs[i].id,
              callback: function ($$v) {
                _vm.$set(items.item.parameter.configs[i], "id", $$v);
              },
              expression: "items.item.parameter.configs[i].id"
            }
          })], 1), _vm.payloadDescriptionForBridgeIdx(i) ? _c(VRow, [_c(VCol, [_c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.payloadDescriptionForBridgeIdx(i))
            }
          })])], 1) : _vm._e(), _c(VRow, _vm._l(Object.keys(_vm.parametersForBridgeIdx(i)), function (param, j) {
            return _c(VCol, {
              key: `actionparam_${i}_${j}`,
              attrs: {
                "cols": "12",
                "sm": "6",
                "md": "4",
                "lg": _vm.getColumnWidth(param, _vm.parametersForBridgeIdx(i)[param])
              }
            }, [_c('core-tenant-bridge-config-field', {
              attrs: {
                "fieldConfig": _vm.parametersForBridgeIdx(i)[param],
                "bridgeType": _vm.methodForBridgeIdx(i).bridge.type,
                "configKey": param,
                "bridgeManifest": _vm.methodForBridgeIdx(i).bridgeType.manifest,
                "bridgeConfig": _vm.methodForBridgeIdx(i).bridge.bridge.config,
                "bridgeConfigId": _vm.methodForBridgeIdx(i).bridge.id,
                "bridgeHasValidParameters": true,
                "bridgeHasValidParametersStrict": false,
                "defaultIcon": null
              },
              on: {
                "changedBridgeParams": function ($event) {
                  return _vm.$refs.form.validate();
                }
              },
              model: {
                value: items.item.parameter.configs[i].params[param],
                callback: function ($$v) {
                  _vm.$set(items.item.parameter.configs[i].params, param, $$v);
                },
                expression: "items.item.parameter.configs[i].params[param]"
              }
            })], 1);
          }), 1)], 1);
        }) : _vm._e()], 2), _c('td', {
          staticStyle: {
            "width": "20px"
          }
        }, [!_vm.readonly ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-trash-alt"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteChainItem(items.index);
            }
          }
        }) : _vm._e()], 1)])];
      }
    }])
  }), _c(VInput, {
    attrs: {
      "value": _vm.chainHasOneBridge,
      "rules": [v => v === true]
    }
  }), _c(VInput, {
    attrs: {
      "value": _vm.chainsLastItemIsBridge,
      "rules": [v => v === true]
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };